/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon64Regular = forwardRef('ArrowDUturnLeftUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M3.382 28a1.5 1.5 0 0 0 2.236 2l14.019-15.668c.112-.126.234-.237.363-.334V35.5C20 46.27 28.73 55 39.5 55S59 46.27 59 35.5v-15a1.5 1.5 0 0 0-3 0v15C56 44.613 48.613 52 39.5 52S23 44.613 23 35.5V13.998c.13.097.25.208.363.334L37.383 30a1.5 1.5 0 1 0 2.235-2L25.598 12.33a5.5 5.5 0 0 0-8.197 0L3.382 28Z" })));
});
